module.exports = "<div class=warehouse-child-row-inner> <table class=\"q-table q-table-stretch q-child-table\"> <tbody> {% _(data).each((childRow)=>{ %} <tr class=child-table-row> {% _(columns).each((column)=>{ %} <td style=\"{%= column.style %}\" class=\"{%= column.className %}\"> {%= column.render ? column.render(childRow[column.data], column.data, childRow) : childRow[column.data] %} </td> {% }) %} </tr> {% }) %} </tbody> </table> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/inventory/lookup/html/warehouseChildRow.html
// module id = 1329
// module chunks = 1